import AlertModal from '../modals/AlertModal.vue';
import { modalRegister } from '../modals/ModalStack.vue';

export function confirmModal<T>({
  title,
  message,
  messageClass = '',
  actionDefaultText = 'Proceed',
  actionDefaultValue,
  actionDefaultVariant = 'default',
  actionCancelText = '',
}: {
  title: string;
  message: string;
  messageClass?: string;
  actionDefaultText?: string;
  actionDefaultValue: T;
  actionDefaultVariant?: 'default' | 'destructive';
  actionCancelText?: string;
}): Promise<T | null> {
  return modalRegister(AlertModal, {
    title,
    message,
    messageClass,
    dangerouslySetInnerHtml: '',
    actionDefaultText,
    actionDefaultValue,
    actionDefaultVariant,
    actionCancelText,
  });
}
